module.exports = __webpack_public_path__ + "static/media/page04.37a71a3f.jpg";